// @generated by web/tools/codegen — DO NOT EDIT
//
// Source: web/manifests/district-census.yaml (2021 Population Census,
//         Census and Statistics Department, HKSAR Government — DATA.GOV.HK)
// Run:    node tools/codegen/main.mjs district-census

/** Census reference year (heading parameter). */
export const CENSUS_YEAR = 2021;

export type DistrictCensus = {
  /** Resident population, male. */
  males: number;
  /** Resident population, female. */
  females: number;
};

const DISTRICT_CENSUS = new Map<string, DistrictCensus>([
  ["Central and Western", { males: 98282, females: 137671 }],
  ["Wan Chai", { males: 67075, females: 99620 }],
  ["Eastern", { males: 233542, females: 296061 }],
  ["Southern", { males: 116239, females: 147039 }],
  ["Sham Shui Po", { males: 197878, females: 233212 }],
  ["Kowloon City", { males: 179518, females: 231116 }],
  ["Wong Tai Sin", { males: 187531, females: 219271 }],
  ["Kwun Tong", { males: 312303, females: 360863 }],
  ["Yau Tsim Mong", { males: 138873, females: 171774 }],
  ["Kwai Tsing", { males: 232213, females: 263585 }],
  ["Tsuen Wan", { males: 146412, females: 173682 }],
  ["Tuen Mun", { males: 240321, females: 266558 }],
  ["Yuen Long", { males: 314056, females: 354024 }],
  ["North", { males: 145343, females: 164288 }],
  ["Tai Po", { males: 146038, females: 170432 }],
  ["Sha Tin", { males: 317927, females: 374879 }],
  ["Sai Kung", { males: 223094, females: 265943 }],
  ["Islands", { males: 84985, females: 100297 }],
]);

/**
 * Census row for a district, keyed by the wire's `district_name.en`
 * (exact `districts.name_en` match). `undefined` = not one of the 18
 * official census districts — callers hide the section (Rails semantics).
 */
export function districtCensus(districtNameEn: string): DistrictCensus | undefined {
  return DISTRICT_CENSUS.get(districtNameEn);
}
